import { useRouter } from 'vue-router';

// Type definition for Matomo window object
declare global {
  interface Window {
    _paq: any[];
    _paqLoaded: boolean;
  }
}

export function useMatomo() {
  const router = useRouter();

  // Function to dynamically load the Matomo script
  const loadMatomoScript = () => {
    if (!window._paq) {
      window._paq = window._paq || [];
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      _paq.push(['setTrackerUrl', '//matomo.forward-audio.com/matomo.php']);
      _paq.push(['setSiteId', '9']);
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = '//matomo.forward-audio.com/matomo.js';
    script.onload = () => console.log('Matomo script loaded successfully.');
    script.onerror = (error) => console.error('Matomo script failed to load:', error);
    document.head.appendChild(script);
    window._paqLoaded = true; // Flag to indicate the script is loaded
  };

  // Function to initialize Matomo tracking
  const initMatomo = async () => {
    if (!window._paqLoaded) {
      loadMatomoScript();
    // Ensure the router is ready before setting up tracking.
    if (router) {
      await router.isReady();

      // Track page views on route changes
      router.afterEach((to) => {
        if (window._paq) {
          window._paq.push(['setCustomUrl', to.fullPath]);
          window._paq.push(['trackPageView']);
        }
      });
    }

    }
  };

  return { initMatomo };
}
